import { useContext, useState } from "react";
import Layout from "../Component/layout/main-layout";
import { useTranslation } from "react-i18next";
import layoutBgImg from "../Images/layout/onlineService.jpg";
import { CalculateAlimony } from "../api/Queries/post";
import { Context } from "../Store/context";
import GlobalLayout from "../Component/layout/global-layout";

const Calculator = () => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { showError } = useContext(Context);
  const [inputValue, setInputValue] = useState("");
  const [numChildren, setNumChildren] = useState("");
  const [alimonyAmount, setAlimonyAmount] = useState("");
  const [calculationType, setCalculationType] = useState("");
  const [isWorking, setIsWorking] = useState("");

  const handlePost = async (e) => {
    e.preventDefault();
    const finalInputValue =
      isWorking === t("no") ? 1410 : Number.parseFloat(inputValue);
    const data = {
      num_children: Number.parseInt(numChildren, 10),
      amount: finalInputValue,
    };
    setIsLoading(true);
    try {
      const res = await CalculateAlimony(data);
      setAlimonyAmount(res?.alimony_amount || "");
    } catch (error) {
      showError(error?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const isFormValid = calculationType && isWorking;
  const isButtonDisabled =
    (isWorking !== t("no") && !inputValue) || !numChildren || isLoading;

  return (
    <GlobalLayout
      title={`${t("calculator")} - ${t("supreme_court")} ${t("turkmenistan")}`}
      keywords="Kalkulýator, Onlaýn kalkulýator, Kalkulyator, 
                Onlayn kalkulyator, Aliment hasaplamak"
    >
      <div className="mb-20">
        <Layout title={t("calculator")} layoutBgImg={layoutBgImg} />

        <div className="media">
          <div
            className="bg-white dark:bg-dark-box dark:text-dark-text
                       px-6 xl:px-16 py-16 mt-8 pt-6"
          >
            <h1
              className="text-primary dark:text-dark-text 
                         text-xl font-bold mb-6"
            >
              {t("calculator")}
            </h1>

            <form>
              <div className="xl:flex gap-16">
                <div className="xl:w-[50%] flex flex-col">
                  <label htmlFor="calculationType">
                    {t("calculation_type_label")}
                  </label>

                  <select
                    id="calculationType"
                    className="w-full px-2 py-2 border border-border 
                               bg-white rounded mt-1 shadow-inner
                               focus:outline-none focus:ring-2 
                               focus:ring-indigo-500 dark:text-white 
                               dark:bg-dark-box dark:border-dark-border"
                    value={calculationType}
                    onChange={(e) => setCalculationType(e.target.value)}
                  >
                    <option value="" hidden>
                      {t("select")}
                    </option>
                    <option value="Aliment" className="px-4 py-1">
                      Aliment
                    </option>
                  </select>
                </div>

                <div className="xl:w-[50%] flex flex-col mt-4 xl:mt-0">
                  <label htmlFor="isWorking">{t("is_working")}</label>

                  <select
                    id="isWorking"
                    className="w-full px-2 py-2 border border-border
                               bg-white rounded mt-1 shadow-inner
                               focus:outline-none focus:ring-2 
                               focus:ring-indigo-500 dark:text-white 
                               dark:bg-dark-box dark:border-dark-border"
                    value={isWorking}
                    onChange={(e) => setIsWorking(e.target.value)}
                  >
                    <option value="" hidden>
                      {t("select")}
                    </option>
                    <option value={t("yes")} className="px-4 py-1">
                      {t("yes")}
                    </option>
                    <option value={t("no")} className="px-4 py-1">
                      {t("no")}
                    </option>
                  </select>
                </div>
              </div>

              {isFormValid && (
                <>
                  <div className="xl:flex gap-16 mt-4 xl:mt-16">
                    <div className="xl:w-[50%] flex flex-col">
                      <label htmlFor="dynamicInput">
                        {isWorking === t("yes")
                          ? t("payers_salary")
                          : t("average_salary")}
                      </label>
                      <input
                        id="dynamicInput"
                        type="number"
                        value={isWorking === t("no") ? 1410 : inputValue}
                        disabled={isWorking === t("no")}
                        onChange={(e) => setInputValue(e.target.value)}
                        className="w-full px-2 py-2 border border-border 
                                   bg-white rounded mt-1 shadow-inner
                                   focus:outline-none focus:ring-2 
                                   focus:ring-indigo-500 dark:text-white 
                                   dark:bg-dark-box dark:border-dark-border"
                      />
                    </div>
                    <div className="xl:w-[50%] flex flex-col mt-4 xl:mt-0">
                      <label htmlFor="numChildren">{t("child_number")}</label>

                      <input
                        id="numChildren"
                        type="number"
                        value={numChildren}
                        onChange={(e) => setNumChildren(e.target.value)}
                        className="w-full px-2 py-2 border border-border 
                                   bg-white rounded mt-1 shadow-inner
                                   focus:outline-none focus:ring-2 
                                   focus:ring-indigo-500 dark:text-white 
                                   dark:bg-dark-box dark:border-dark-border"
                      />
                    </div>
                  </div>

                  <div
                    className="mt-8 flex flex-col w-full justify-center gap-2
                               items-center dark:text-dark-text text-center"
                  >
                    {t("paid_alimony")}

                    <div
                      className="flex items-center border border-border
                                 dark:border-dark-border"
                    >
                      <p className="py-2 px-6">
                        {alimonyAmount || "..."}
                      </p>
                      <button
                        type="submit"
                        onClick={handlePost}
                        className={`relative bg-primary text-white py-2 px-6 min-w-[100px]
                                    flex items-center justify-center
                                    ${isButtonDisabled ? "bg-border cursor-not-allowed" : ""}`}
                        disabled={isButtonDisabled}
                      >
                        <span className={isLoading ? "invisible" : "visible"}>
                          {t("count")}
                        </span>

                        {isLoading && (
                          <span className="absolute w-4 h-4 border-2 border-white 
                                          border-t-transparent rounded-full animate-spin"
                          />
                        )}
                      </button>
                    </div>
                    {t("calculated")}
                  </div>
                </>
              )}
            </form>
          </div>
        </div>
      </div>
    </GlobalLayout>
  );
};

export default Calculator;